import { app } from '../../../../../bootstrap/core';
import { dwsCompletedState } from './completed.state';
import { dwsCompletedComponent } from './completed.component';

app.config(dwsCompletedState);
app.component(dwsCompletedComponent.name, dwsCompletedComponent);
